<template>
	<div class="product-table">
		<p class="product-table__small-title">
			Logs of items/orders scanned for delivery
		</p>
		<table class="product-table__table">
			<thead>
				<tr>
					<th>Order ID</th>
					<th>ITEM ID</th>
					<th>NAME</th>
					<th>SITE</th>
					<th>Dest</th>
					<th>Shipper</th>
					<th>Shipping Type</th>
					<th>Weight</th>
					<th>Scanned</th>
					<th><abbr title="AirWay Bill">AWB</abbr></th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="index in 1" :key="index">
					<td>{{ index }}</td>
					<td>753037</td>
					<td>PILLOW</td>
					<td>GB</td>
					<td>FR</td>
					<td>DPD/MAIL-INIT</td>
					<td>STANDARD</td>
					<td>0.356kg</td>
					<td>YES</td>
					<td>CREATE</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>

<script>
import Vue from "vue";
export default Vue.extend({
	name: "",
	components: {}
});
</script>

<style lang="scss" scoped>
.product-table {
	padding: 10px 0 20px;

	&__small-title {
		text-align: center;
		padding: 10px 0 20px;
		font-weight: 600;
		font-size: 14px;
	}

	&__table {
		margin: 0 auto;

		th,
		td {
			border: 1px solid $border-color;
			text-align: center;
			font-size: 14px;
			padding: 7px 0;
		}

		th {
			background-color: lighten($color7, 10%);
			font-weight: 500;
			width: 120px;
		}

		td {
			background-color: $table-light-bg;
		}
	}
}
</style>